import { LoadDirectory } from "@/Utils/Promises";
import { Select } from "@theorgchartdev/storybook";
import { useAsyncEffect } from "@/hooks/useAsyncEffect";
import { BuildBackgroundOptions } from "@/appComponents/Navigation/RightSidebar/BackgroundDisplay/Backgrounds.utils";
import { IsBackgroundFile } from "@coreapp/utils/IsBackgroundFile";
import { GetExtension } from "@coreapp/utils/GetExtension";
import { appstr } from "@coreapp/utils/appstr";

const BackgroundSection = props => {
  const SetBackground = target => {
    let background = target.value;
    if (!IsBackgroundFile(background)) {
      background = null;
    }
    const rule = props.rule.Clone();
    rule.SetMasterName(background);
    props.setRule(rule);
  };

  const { data, loading } = useAsyncEffect(async () => {
    const result = await LoadDirectory("Masters", "Masters");
    return result.processedResults;
  });

  let curBackground = props.rule.GetMasterName();
  if (curBackground) {
    let curExt = GetExtension(curBackground);
    if (curExt == null || curExt === "") curBackground = curBackground + ".oc5m";
  }

  return (
    <Select
      optionSize="small"
      disabled={loading}
      id="select-criteria-type-button-"
      placeholder={appstr("notset")}
      value={curBackground}
      options={BuildBackgroundOptions("cs-background-select", data || [], SetBackground)}
    />
  );
};

export default BackgroundSection;
